import { useI18n } from '../lib/i18n';
import Icon from './Icon';

// ============================================================
// Pravila za lozinku — ista za registraciju, reset i promenu lozinke
// ============================================================

const TEXT = {
  sr: { title: 'Lozinka mora da ima:', len: 'najmanje 8 karaktera', upper: 'bar jedno veliko slovo (A–Z)', special: 'bar jedan specijalni znak (npr. ! @ # $ % . -)' },
  en: { title: 'Password must have:', len: 'at least 8 characters', upper: 'at least one uppercase letter (A–Z)', special: 'at least one special character (e.g. ! @ # $ % . -)' },
  ru: { title: 'Пароль должен содержать:', len: 'не менее 8 символов', upper: 'хотя бы одну заглавную букву (A–Z)', special: 'хотя бы один специальный символ (например ! @ # $ % . -)' },
};

export const PASSWORD_RULES = [
  { id: 'len', test: (p) => p.length >= 8 },
  { id: 'upper', test: (p) => /[A-ZČĆŽŠĐА-ЯЁ]/.test(p) },
  { id: 'special', test: (p) => /[^A-Za-z0-9ČĆŽŠĐčćžšđА-Яа-яЁё\s]/.test(p) },
];

export const passwordOk = (p) => PASSWORD_RULES.every((r) => r.test(p || ''));

export default function PasswordRules({ password = '' }) {
  const { lang } = useI18n();
  const tx = TEXT[lang] || TEXT.sr;
  return (
    <div style={styles.box} aria-live="polite">
      <div style={styles.title}>{tx.title}</div>
      {PASSWORD_RULES.map((r) => {
        const ok = r.test(password);
        return (
          <div key={r.id} style={{ ...styles.row, color: ok ? 'var(--forest-600)' : 'var(--ink-500)' }}>
            <span style={{ ...styles.dot, ...(ok ? styles.dotOk : {}) }}>
              {ok && <Icon name="check" size={11} strokeWidth={3} color="#fff" />}
            </span>
            {tx[r.id]}
          </div>
        );
      })}
    </div>
  );
}

const styles = {
  box: { background: 'var(--paper)', border: '1px solid var(--line)', borderRadius: 10, padding: '10px 12px', marginBottom: 12 },
  title: { fontSize: 12, fontWeight: 700, color: 'var(--ink-700)', marginBottom: 6 },
  row: { display: 'flex', alignItems: 'center', gap: 8, fontSize: 12.5, lineHeight: 1.8 },
  dot: { width: 16, height: 16, borderRadius: '50%', border: '1.5px solid var(--ink-300)', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 },
  dotOk: { background: 'var(--forest-500)', borderColor: 'var(--forest-500)' },
};
